/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeListing } from '../models/EmployeeListing';
import type { MaintenanceRequest } from '../models/MaintenanceRequest';
import type { MaintenanceRequestResponse } from '../models/MaintenanceRequestResponse';
import type { PaginatedMaintenanceResponse } from '../models/PaginatedMaintenanceResponse';
import type { StaffSurveySubmissionDetails } from '../models/StaffSurveySubmissionDetails';
import { request as __request } from '../core/request';

export class MaintenanceRequestService {

    /**
     * create maintenance request
     * @returns MaintenanceRequestResponse The fetch staff survey form
     * @throws ApiError
     */
    public static async createMaintenanceRequest({
companyId,
requestBody,
}: {
/** The companyId **/
companyId: number,
requestBody: any,
}): Promise<MaintenanceRequestResponse> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/maintenance`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get all maintenance requests
     * @returns StaffSurveySubmissionDetails The fetch staff active survey form
     * @throws ApiError
     */
    public static async getMaintenanceRequests({
companyId,
assignee,
status,
limit,
offset,
createdAt,
completedAt,
}: {
/** The companyId **/
companyId: number,
/** The assignee id **/
assignee?: number,
/** The status id **/
status?: number,
/** The limit **/
limit?: number,
/** The offset **/
offset?: number,
/** Start date (YYYY-MM-DD or RFC3339) **/
createdAt?: string,
/** Start date (YYYY-MM-DD or RFC3339) **/
completedAt?: string,
}): Promise<StaffSurveySubmissionDetails> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/maintenance`,
            query: {
                'assignee': assignee,
                'status': status,
                'limit': limit,
                'offset': offset,
                'createdAt': createdAt,
                'completedAt': completedAt,
            },
        });
        return result.body;
    }

    /**
     * get all maintenance employees
     * @returns EmployeeListing The fetch employees belongs to maintenance department
     * @throws ApiError
     */
    public static async getMaintenanceEmployees({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<EmployeeListing> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/maintenance/employees`,
        });
        return result.body;
    }

    /**
     * update maintenance request
     * @returns MaintenanceRequestResponse Update Maintenance Request data
     * @throws ApiError
     */
    public static async updateMaintenanceRequest({
companyId,
maintenanceId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
maintenanceId: number,
requestBody: any,
}): Promise<MaintenanceRequestResponse> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/maintenance/${maintenanceId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get maintenance request detail
     * @returns PaginatedMaintenanceResponse The fetch maintenance request by id
     * @throws ApiError
     */
    public static async getMaintenanceRequest({
companyId,
maintenanceId,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
maintenanceId: number,
}): Promise<PaginatedMaintenanceResponse> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/maintenance/${maintenanceId}`,
        });
        return result.body;
    }

    /**
     * delete maintenance request
     * @returns any Delete Maintenance Request
     * @throws ApiError
     */
    public static async deleteMaintenanceRequest({
companyId,
maintenanceId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
maintenanceId: number,
requestBody: MaintenanceRequest,
}): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/maintenance/${maintenanceId}`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update maintenance request
     * @returns MaintenanceRequestResponse Update Maintenance Request data
     * @throws ApiError
     */
    public static async updateMaintenanceRequestStatus({
companyId,
maintenanceId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
maintenanceId: number,
requestBody: any,
}): Promise<MaintenanceRequestResponse> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/maintenance/${maintenanceId}/status`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update maintenance request
     * @returns MaintenanceRequestResponse Update Maintenance Request data
     * @throws ApiError
     */
    public static async updateMaintenanceRequestAssignee({
companyId,
maintenanceId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The companyId **/
maintenanceId: number,
requestBody: MaintenanceRequest,
}): Promise<MaintenanceRequestResponse> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/maintenance/${maintenanceId}/assignee`,
            body: requestBody,
        });
        return result.body;
    }

}